import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import {
  Box, Typography, Paper, CircularProgress,
  TextField, Button
} from '@mui/material';

const MeetingReport = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [dates, setDates] = useState({ start_date: '', end_date: '' });
  const printRef = useRef();

  const fetchData = () => {
    setLoading(true);
    axios
      .get(`https://feemanagementsystem.oxfordconventschoolkhajuri.com/backend/api/meeting_report.php`, {
        params: dates,
        withCredentials: true
      })
      .then(res => {
        if (res.data.success) setData(res.data.data);
        else setData(null);
        setLoading(false);
      })
      .catch(err => {
        console.error(err);
        setData(null);
        setLoading(false);
      });
  };

  // Use template literals and proper interpolation here:
  const tableMarkup = data ? `
    <table style="width:100%;border-collapse:collapse;margin-top:10px;">
      <tr>
        <th style="border:1px solid #222;padding:8px;text-align:left;background:#f5f5f5;">Category</th>
        <th style="border:1px solid #222;padding:8px;text-align:right;background:#f5f5f5;">Amount (₹)</th>
      </tr>
      <tr>
        <td style="border:1px solid #222;padding:8px;">Coaching Fees</td>
        <td style="border:1px solid #222;padding:8px;text-align:right;">${data.coaching_fees}</td>
      </tr>
      <tr>
        <td style="border:1px solid #222;padding:8px;">Fee Payments</td>
        <td style="border:1px solid #222;padding:8px;text-align:right;">${data.fee_payments}</td>
      </tr>
      <tr>
        <td style="border:1px solid #222;padding:8px;">Old School Fee</td>
        <td style="border:1px solid #222;padding:8px;text-align:right;">${data.oldschoolfee}</td>
      </tr>
      <tr>
        <td style="border:1px solid #222;padding:8px;">Other Payments</td>
        <td style="border:1px solid #222;padding:8px;text-align:right;">${data.other_payments}</td>
      </tr>
      <tr>
        <td style="border:1px solid #222;padding:8px;">Van Payments</td>
        <td style="border:1px solid #222;padding:8px;text-align:right;">${data.van_payments}</td>
      </tr>
      <tr>
        <td style="border:1px solid #222;padding:8px;">Miscellaneous Expenses</td>
        <td style="border:1px solid #222;padding:8px;text-align:right;">${data.miscellaneous_expenses}</td>
      </tr>
      <tr>
        <td style="border:1px solid #222;padding:8px;">Concession</td>
        <td style="border:1px solid #222;padding:8px;text-align:right;">${data.concession}</td>
      </tr>
      <tr>
        <td style="border:1px solid #222;padding:8px;font-weight:bold;">Total Credited</td>
        <td style="border:1px solid #222;padding:8px;text-align:right;font-weight:bold;">${data.total_credited}</td>
      </tr>
      <tr>
        <td style="border:1px solid #222;padding:8px;font-weight:bold;">Total Debited</td>
        <td style="border:1px solid #222;padding:8px;text-align:right;font-weight:bold;">${data.total_debited}</td>
      </tr>
      <tr style="background:#ffe0b2;">
        <td style="border:1px solid #222;padding:8px;font-weight:bold;">Net Balance</td>
        <td style="border:1px solid #222;padding:8px;text-align:right;font-weight:bold;">${data.total_credited - data.total_debited}</td>
      </tr>
    </table>
  ` : '';

  const handlePrint = () => {
    if (!data) return alert('No data to print!');

    // Format dates for printing (if set)
    const formatDate = (dateStr) => {
      if (!dateStr) return '';
      const d = new Date(dateStr);
      return d.toLocaleDateString();
    };

    const startDateFormatted = formatDate(dates.start_date);
    const endDateFormatted = formatDate(dates.end_date);

    // Prepare date range text
    let dateRangeText = 'Date Range: ';
    if (startDateFormatted) dateRangeText += startDateFormatted;
    if (startDateFormatted && endDateFormatted) dateRangeText += ' - ';
    if (endDateFormatted) dateRangeText += endDateFormatted;
    if (!startDateFormatted && !endDateFormatted) dateRangeText = '';

    const printContents = tableMarkup;
    const newWindow = window.open('', '_blank');
    newWindow.document.write(`
      <html>
        <head>
          <title>Meeting Report</title>
          <style>
            body { font-family: Arial, sans-serif; background: #fff; }
            .print-box {
              border: 2px solid #222;
              padding: 32px 36px;
              margin: 28px auto;
              width: 80vw;
              background: #fff;
            }
            .school-logo {
              display: block;
              margin: 0 auto 10px auto;
              width: 70px;
              height: 70px;
              object-fit: contain;
            }
            .school-title {
              text-align: center;
              font-size: 22px;
              font-weight: bold;
              margin-bottom: 6px;
            }
            .school-address {
              text-align: center;
              font-size: 14px;
              color: #555;
              margin-bottom: 6px;
            }
            .date-range {
              text-align: center;
              font-size: 16px;
              font-weight: 500;
              margin-bottom: 20px;
              color: #333;
            }
            .report-title {
              text-align: center;
              font-size: 21px;
              font-weight: 600;
              margin-bottom: 28px;
              margin-top: 10px;
              letter-spacing: 1.5px;
            }
            table { width:100%; border-collapse:collapse; margin-top:20px;}
            th, td { border:1px solid #222; padding:8px; text-align:left; font-size: 16px;}
            th { background:#f5f5f5; text-align:center;}
            tr:last-child td { font-weight: bold; }
          </style>
        </head>
        <body>
          <div class="print-box">
            <img src="/school-logo.jpg" alt="Logo" class="school-logo"/>
            <div class="school-title">OXFORD CONVENT ENGLISH MEDIUM SCHOOL, KHAJURI</div>
            <div class="school-address">Khajuri - 585314, Tq. Aland, Dist. Kalaburagi</div>
            ${dateRangeText ? `<div class="date-range">${dateRangeText}</div>` : ''}
            <div class="report-title">Meeting Report</div>
            ${printContents}
          </div>
        </body>
      </html>
    `);
    newWindow.document.close();
    newWindow.print();
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // empty deps to only fetch once on mount

  return (
    <Box sx={{ p: 3 }}>
      {/* Header with logo and name */}
      <img
        src="/school-logo.jpg"
        alt="School Logo"
        style={{ display: 'block', margin: '0 auto 10px auto', width: 65, height: 65, objectFit: 'contain' }}
      />
      <div style={{ textAlign: 'center', fontWeight: 'bold', fontSize: 22 }}>
        OXFORD CONVENT ENGLISH MEDIUM SCHOOL, KHAJURI
      </div>
      <div style={{ textAlign: 'center', fontSize: 14, color: '#555', marginBottom: 7 }}>
        Khajuri - 585314, Tq. Aland, Dist. Kalaburagi
      </div>
      <Typography variant="h5" align="center" sx={{ mb: 2, fontWeight: 600, letterSpacing: 1 }}>
        Meeting Report
      </Typography>

      {/* Date Filters & Actions */}
      <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, mb: 2 }}>
        <TextField
          type="date"
          label="Start Date"
          InputLabelProps={{ shrink: true }}
          value={dates.start_date}
          onChange={e => setDates({ ...dates, start_date: e.target.value })}
        />
        <TextField
          type="date"
          label="End Date"
          InputLabelProps={{ shrink: true }}
          value={dates.end_date}
          onChange={e => setDates({ ...dates, end_date: e.target.value })}
        />
        <Button variant="contained" onClick={fetchData}>
          Fetch
        </Button>
        {/* Disable print if no data */}
        <Button variant="outlined" onClick={handlePrint} disabled={!data}>
          Print
        </Button>
      </Box>

      {/* Main Table Display */}
      {loading ? (
        <Box sx={{ textAlign: 'center', mt: 6 }}>
          <CircularProgress />
        </Box>
      ) : data ? (
        <Paper sx={{ p: 2, mt: 2, maxWidth: 600, margin: "0 auto" }} ref={printRef}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <tbody>
              <tr>
                <th style={{ border: '1px solid #222', padding: 8, background: '#f5f5f5', textAlign: 'left' }}>Category</th>
                <th style={{ border: '1px solid #222', padding: 8, background: '#f5f5f5', textAlign: 'right' }}>Amount (₹)</th>
              </tr>
              <tr>
                <td style={{ border: '1px solid #222', padding: 8 }}>Coaching Fees</td>
                <td style={{ border: '1px solid #222', padding: 8, textAlign: 'right' }}>{data.coaching_fees}</td>
              </tr>
              <tr>
                <td style={{ border: '1px solid #222', padding: 8 }}>Fee Payments</td>
                <td style={{ border: '1px solid #222', padding: 8, textAlign: 'right' }}>{data.fee_payments}</td>
              </tr>
              <tr>
                <td style={{ border: '1px solid #222', padding: 8 }}>Old School Fee</td>
                <td style={{ border: '1px solid #222', padding: 8, textAlign: 'right' }}>{data.oldschoolfee}</td>
              </tr>
              <tr>
                <td style={{ border: '1px solid #222', padding: 8 }}>Other Payments</td>
                <td style={{ border: '1px solid #222', padding: 8, textAlign: 'right' }}>{data.other_payments}</td>
              </tr>
              <tr>
                <td style={{ border: '1px solid #222', padding: 8 }}>Van Payments</td>
                <td style={{ border: '1px solid #222', padding: 8, textAlign: 'right' }}>{data.van_payments}</td>
              </tr>
              <tr>
                <td style={{ border: '1px solid #222', padding: 8 }}>Miscellaneous Expenses</td>
                <td style={{ border: '1px solid #222', padding: 8, textAlign: 'right' }}>{data.miscellaneous_expenses}</td>
              </tr>
              <tr>
                <td style={{ border: '1px solid #222', padding: 8 }}>Concession</td>
                <td style={{ border: '1px solid #222', padding: 8, textAlign: 'right' }}>{data.concession}</td>
              </tr>
              <tr>
                <td style={{ border: '1px solid #222', padding: 8, fontWeight: 'bold' }}>Total Credited</td>
                <td style={{ border: '1px solid #222', padding: 8, textAlign: 'right', fontWeight: 'bold' }}>{data.total_credited}</td>
              </tr>
              <tr>
                <td style={{ border: '1px solid #222', padding: 8, fontWeight: 'bold' }}>Total Debited</td>
                <td style={{ border: '1px solid #222', padding: 8, textAlign: 'right', fontWeight: 'bold' }}>{data.total_debited}</td>
              </tr>
              <tr style={{ background: '#ffe0b2' }}>
                <td style={{ border: '1px solid #222', padding: 8, fontWeight: 'bold' }}>Net Balance</td>
                <td style={{ border: '1px solid #222', padding: 8, textAlign: 'right', fontWeight: 'bold' }}>{data.total_credited - data.total_debited}</td>
              </tr>
            </tbody>
          </table>
        </Paper>
      ) : (
        <Typography color="error" sx={{ mt: 3, textAlign: 'center' }}>
          Failed to load report
        </Typography>
      )}
    </Box>
  );
};

export default MeetingReport;
